<template>
    <v-card flat hover elevation="20">
        <v-card-title primary-title text-center>
            <h4>Сброс пароля</h4>
        </v-card-title>
        <v-card-text>
            <v-form
                    ref="form"
                    v-model="valid"
            >
                <v-text-field
                        prepend-icon="lock"
                        label="Введите новый пароль"
                        v-model="userModel.password"
                        :error-messages="errorPassword"
                        required
                        autofocus
                        :rules="[rules.required, rules.counter]"
                ></v-text-field>
                <v-text-field
                        prepend-icon="lock"
                        label="Подтвердите новый пароль"
                        v-model="userModel.passwordRepeat"
                        :error-messages="errorPassword"
                        required
                        :rules="[rules.required, rules.counter]"
                ></v-text-field>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-row>
                <v-col cols="12" xs12 >
                    <v-card class="d-flex justify-center" flat>
                        <v-btn
                                :disabled="!valid"
                                color="primary"
                                block
                                @click="changePassword"
                                text
                        >
                            Изменить пароль
                        </v-btn>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-actions>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-card>
</template>

<script>
import axios from 'axios'
import constConf from '../../constconf'
export default {
    name: 'SendMessagePasswordReset',
    data() {
        return {
            snackbar: false,
            paramsSnackbar: {
                color: 'success',
                text: 'Пароль успешно отправлен'
            },
            rules: {
                required: value => !!value || 'Обязательное поле.',
                counter: value => value.length >= 6 || 'Минимальная длина пароля 6 символов.'
            },
            userModel: {
                password: '',
                passwordRepeat: ''
            },
            valid: false
        }
    },
    methods: {
        changePassword() {
            axios.defaults.withCredentials = true
            axios.post(constConf.baseURLApi + '/user/user/password-reset?token=' + this.$route.query.token, this.userModel)
                .then(response => {
                    if (!response.data.hasOwnProperty('error')) {
                        this.userModel.password = ''
                        this.userModel.passwordRepeat = ''
                        this.paramsSnackbar.color = 'success'
                        this.paramsSnackbar.text = response.data.success.text
                        this.snackbar = true
                        this.messageSend = true
                        setTimeout(() => {
                            this.$router.push('/login')
                        }, 3000)
                    } else {
                        this.paramsSnackbar.color = 'error'
                        this.paramsSnackbar.text = response.data.error.text
                        this.snackbar = true
                    }
                })
                .catch(error => {
                    this.paramsSnackbar.color = 'error'
                    this.paramsSnackbar.text = 'Пароль неизменен, повторите попытку позже или напишите Администратору'
                    this.snackbar = true
                })
        }
    },
    computed: {
        errorPassword() {
            return this.userModel.password === this.userModel.passwordRepeat ? null : 'Пароли должны совпадать'
        }
    },
    created() {
        if (this.$route.query.token) {
            console.log(this.$route.query)
        } else {
            this.$router.push('/')
        }
    }
}
</script>

<style scoped>

</style>
